import { render, staticRenderFns } from "./moduleTutorial.vue?vue&type=template&id=0ba3fe70&scoped=true&"
import script from "./moduleTutorial.vue?vue&type=script&lang=js&"
export * from "./moduleTutorial.vue?vue&type=script&lang=js&"
import style0 from "./moduleTutorial.vue?vue&type=style&index=0&id=0ba3fe70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3fe70",
  null
  
)

export default component.exports